import { FC } from 'react'
import StandingsHeaderWithConfig from '@sport1/news-styleguide/StandingsHeaderWithConfig'

const DefaultHeader: FC = () => (
    <StandingsHeaderWithConfig
        columns={[
            {
                value: 'Sp.',
                width: [30, 30, 56, 56],
            },
            {
                value: 'S-N',
                width: [40, 40, 56, 56],
            },
            {
                value: 'Pkt.',
                width: [34, 34, 56, 56],
            },
            {
                value: 'Heim',
                width: [0, 0, 64, 64],
                display: ['none', 'none', 'flex', 'flex'],
            },
            {
                value: 'Gast',
                width: [0, 0, 56, 64],
                display: ['none', 'none', 'flex', 'flex'],
            },
            {
                value: '+/-',
                width: [0, 0, 80, 80],
                display: ['none', 'none', 'flex', 'flex'],
            },
            {
                value: 'Diff.',
                width: [40, 40, 56, 64],
            },
        ]}
    />
)

export default DefaultHeader
